import { render, staticRenderFns } from "./BaseClientBadge.vue?vue&type=template&id=e295cf42&scoped=true"
import script from "./BaseClientBadge.vue?vue&type=script&lang=js"
export * from "./BaseClientBadge.vue?vue&type=script&lang=js"
import style0 from "./BaseClientBadge.vue?vue&type=style&index=0&id=e295cf42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e295cf42",
  null
  
)

export default component.exports